import React from 'react';
import { components as ReactSelectComponents } from 'react-select';
import { SEARCH_VALUE_MAX_LENGTH } from '../../../../constants';

const LimitedSelectInput = inputProps => (
    <ReactSelectComponents.Input {...inputProps} maxLength={SEARCH_VALUE_MAX_LENGTH} />
);

export default LimitedSelectInput;
